module.exports = __webpack_public_path__ + "img/icon_4_25.73b513ba.png";